import { createFileRoute, notFound } from "@tanstack/react-router";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { getPublicAuditRun } from "@/lib/audit.functions";
import { AuditBadge } from "@/components/audit/AuditBadge";

function embedQueryOptions(slug: string) {
  return queryOptions({
    queryKey: ["embedAudit", slug],
    queryFn: async () => {
      const en = await getPublicAuditRun({ data: { slug, locale: "en" } });
      if (en) return en;
      const es = await getPublicAuditRun({ data: { slug, locale: "es" } });
      return es;
    },
  });
}

export const Route = createFileRoute("/embed/audit-badge/$slug")({
  loader: async ({ params, context }) => {
    const run = await context.queryClient.ensureQueryData(embedQueryOptions(params.slug));
    if (!run) throw notFound();
    return null;
  },
  head: () => ({
    meta: [
      { title: "Audited by Shugert" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  errorComponent: () => null,
  notFoundComponent: () => null,
  component: function AuditBadgeRoute() {
    const params = Route.useParams();
    const { data } = useSuspenseQuery(embedQueryOptions(params.slug));
    if (!data) return null;
    return <AuditBadge run={data} />;
  },
});